import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const iconInstagram = '/images/icons/instagram-icon.svg';

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="footer-row">
        <p className="footer-copyright">GoBagApp, LLC, 2026</p>

        <nav className="footer-links" aria-label="Legal">
          <Link to="/about" className="footer-link">
            About
          </Link>
          <Link to="/use-cases" className="footer-link">
            Use Cases
          </Link>
          <Link to="/terms" className="footer-link">
            Terms of Use
          </Link>
          <Link to="/privacy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/contact" className="footer-link">
            Contact
          </Link>
        </nav>

        <div className="footer-social">
          <span className="footer-follow-label">Follow us</span>
          <div className="footer-social-actions">
            <a
              href="https://www.instagram.com/trygobag/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link footer-social-link--instagram"
              aria-label="GoBag on Instagram (@trygobag)"
            >
              <span className="footer-social-link__icon" aria-hidden>
                <img src={iconInstagram} alt="" loading="lazy" decoding="async" />
              </span>
              <span className="footer-social-handle">@trygobag</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
